export default function RuleUpdateModal({ count, onUpdate, onSkip, onCancel }) {
  return (
    <div style={{ padding: "1rem", backgroundColor: "#fff", borderRadius: "8px" }}>
      <h3>Update Past Transactions?</h3>
      <p>We found {count} past transactions that match this rule’s pattern. Do you want to update them to use the new category and subcategory?</p>
      <button
        onClick={onUpdate}
        style={{ backgroundColor: "#00B074", color: "white", border: "none", padding: "0.5rem 1rem", borderRadius: "6px", cursor: "pointer" }}
      >
        ✅ Update All
      </button>
      <button
        onClick={onSkip}
        style={{ backgroundColor: "#00B074", color: "white", border: "none", padding: "0.5rem 1rem", borderRadius: "6px", cursor: "pointer" }}
      >
        🚫 Future Only
      </button>
      <button
        onClick={onCancel}
        style={{ backgroundColor: "#333", color: "white", border: "none", padding: "0.5rem 1rem", borderRadius: "6px", cursor: "pointer" }}
      >
        Cancel
      </button>
    </div>
  );
}
